import { Vue, Prop, Component } from "vue-property-decorator";

@Component
export default class NotificationList extends Vue {
    @Prop() id!: string;
    @Prop() username!: string;
    @Prop() tenantId!: string;
    @Prop() staffId!: number;
    @Prop() message!: string;
    @Prop() body!: string;
    @Prop() read!: boolean;
    @Prop() urgent!: boolean;
    @Prop() actionableBy!: string;
  }